import {
  MilkEntity,
} from './milkEntity';
import { MeasureDateTime } from './valueObjects/measureDateTime';
import { MeasurerId } from './valueObjects/measurerId';
import { MeasurerType } from './valueObjects/measurerType';
import { Milk } from './valueObjects/milk';
import { ParentId } from './valueObjects/parentId';

import type {
  MilkPropsPub,
  MilkPropsPvt,
} from './milkEntity';
import type { EntityDataPubType } from '@/domain/entityBase';
import type { EntityDataPubNotNullType, EntityPubNotNullType } from '@/domain/entityPub';
import type { MilkJsonPub, MilkJsonPvt } from '@/types/domain/milk/entities/milkEntity';

import { FactoryPub } from '@/domain/factoryPub';

export class MilkFactory extends FactoryPub<
  MilkEntity,
  MilkPropsPvt,
  MilkJsonPvt,
  MilkPropsPub,
  MilkJsonPub
> {
  comparePub = (
    a: EntityDataPubType<MilkJsonPvt, MilkJsonPub>,
    b: EntityDataPubType<MilkJsonPvt, MilkJsonPub>,
  ) => {
    const da = new Date(a.data.measureDateTime);
    const db = new Date(b.data.measureDateTime);
    return da < db ? 1 : -1;
  };

  create(
    props: MilkPropsPvt,
    propsPub: EntityPubNotNullType<MilkPropsPub>,
  ): MilkEntity {
    return new MilkEntity(props, propsPub);
  }

  createFromEntityDataPub(
    props: EntityDataPubNotNullType<MilkJsonPvt, MilkJsonPub>,
  ): MilkEntity {
    return this.create({
      measureDateTime: MeasureDateTime.create(new Date(props.data.measureDateTime)),
      measurerId: MeasurerId.create(props.data.measurerId),
      measurerType: MeasurerType.create(props.data.measurerType),
      parentId: ParentId.create(props.data.parentId),
      childId: ParentId.create(props.data.childId),
      milk: Milk.create(props.data.milk),
    }, {
      sendId: props.pub.sendId,
      replyId: props.pub.replyId,
      data: {},
    });
  }
}
